import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { UserService } from "../authentication/user.service";

@Injectable({
    providedIn: 'root'
})
export class AuthGuardService  {
    constructor(
        private user: UserService,
        private router: Router
    ) { }

    async canActivate(): Promise<boolean> {
        if (this.user.currentUser) return true;
        this.router.navigate(['/authentication']);
        return false;
    }
}
